module.exports = __webpack_public_path__ + "static/media/classics-2-4.a455e60b.jpg";